// src/utils/analytics.js

import ReactGA from 'react-ga4';

const MEASUREMENT_ID = 'G-GBTME959QR';

// Skip initializing in development (localhost)
export const initGA = () => {
  if (window.location.hostname === 'localhost') return;
  ReactGA.initialize(MEASUREMENT_ID);
};

// Track route-based page views
export const trackPageView = (url) => {
  if (window.location.hostname === 'localhost') return;
  ReactGA.send({ hitType: 'pageview', page: url });
};

//Track custom events like clicks, interactions
export const trackEvent = (category, action, label = '') => {
  if (window.location.hostname === 'localhost') return;
  ReactGA.event({ category, action, label });
};
